import { display, type DisplayProps } from '@material-ui/system'
import styled from 'styled-components'

interface IPopoverTriggerStyledProps extends DisplayProps {
  block?: boolean
}

export const PopoverTriggerStyled = styled.div<IPopoverTriggerStyledProps>`
  display: ${(props) => (props.block ? `block` : `inline-block`)};

  ${display}
`
